import { Navigate, Route, Routes } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import AppLayout from '../layouts/AppLayout';
import RequirePermission from '../components/RequirePermission';
import HomePage from '../pages/HomePage';
import ScanPage from '../pages/ScanPage';
import ScanResultPage from '../pages/ScanResultPage';
import CoaPage from '../pages/CoaPage';
import DataPage from '../pages/DataPage';
import CustomersPage from '../pages/CustomersPage';
import CustomerFormPage from '../pages/CustomerFormPage';
import SpecPage from '../pages/SpecPage';
import SpecFormPage from '../pages/SpecFormPage';
import GradesPage from '../pages/GradesPage';
import MembersPage from '../pages/MembersPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/scan/result/:id/coa"
          element={
            <RequirePermission permission="inspections.export_coa">
              <CoaPage />
            </RequirePermission>
          }
        />
        <Route element={<AppLayout />}>
          <Route
            path="/"
            element={
              <RequirePermission permission="dashboard.read">
                <HomePage />
              </RequirePermission>
            }
          />
          <Route
            path="/scan"
            element={
              <RequirePermission permission="inspections.create">
                <ScanPage />
              </RequirePermission>
            }
          />
          <Route
            path="/scan/result/:id"
            element={
              <RequirePermission permission="inspections.read">
                <ScanResultPage />
              </RequirePermission>
            }
          />
          <Route
            path="/data"
            element={
              <RequirePermission permission="inspections.read">
                <DataPage />
              </RequirePermission>
            }
          />
          <Route path="/history" element={<Navigate to="/data" replace />} />
          <Route
            path="/customers"
            element={
              <RequirePermission permission="customers.read">
                <CustomersPage />
              </RequirePermission>
            }
          />
          <Route
            path="/customers/new"
            element={
              <RequirePermission permission="customers.manage">
                <CustomerFormPage />
              </RequirePermission>
            }
          />
          <Route
            path="/customers/:id/edit"
            element={
              <RequirePermission permission="customers.manage">
                <CustomerFormPage />
              </RequirePermission>
            }
          />
          <Route
            path="/grades"
            element={
              <RequirePermission permission="masters.read">
                <GradesPage />
              </RequirePermission>
            }
          />
          <Route
            path="/spec"
            element={
              <RequirePermission permission="masters.read">
                <SpecPage />
              </RequirePermission>
            }
          />
          <Route
            path="/spec/new"
            element={
              <RequirePermission permission="masters.manage">
                <SpecFormPage />
              </RequirePermission>
            }
          />
          <Route
            path="/spec/:id/edit"
            element={
              <RequirePermission permission="masters.manage">
                <SpecFormPage />
              </RequirePermission>
            }
          />
          <Route
            path="/members"
            element={
              <RequirePermission permission="members.manage">
                <MembersPage />
              </RequirePermission>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
